import { Stack, Autocomplete, TextField, CircularProgress, Box, createFilterOptions } from '@mui/material';
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

const FacilitiesAutoComplete = ({ selectedFacilities, selectedCustomer, facilityDropdown, setSelectedFacilities, fetchFacilities }) => {
    const { t } = useTranslation("translations");
    const loading = useSelector((store) => store.customer.loading);

    useEffect(() => {
        fetchFacilities();
    }, []);

    const handleFacilitySelection = (event, newValue) => {
        setSelectedFacilities(newValue);
    }

    useEffect(() => {
        if (selectedCustomer) {
            setSelectedFacilities([]);
        }
    }, [selectedCustomer]);


    return (
        <Box sx={{ width: 500 }}>

            <Autocomplete
                autoHighlight
                multiple
                filterSelectedOptions
                fullWidth
                id="facility-dropdown"
                value={selectedFacilities}
                onChange={handleFacilitySelection}
                options={facilityDropdown}
                isOptionEqualToValue={(option, selectedValue) => {
                    return option.value === selectedValue.value;
                }}
                getOptionLabel={(option) => option.name}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={t("Facility Selection")}
                        variant="outlined"
                        InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                                <React.Fragment>
                                    {loading ? <CircularProgress color="secondary" size={20} /> : null}
                                    {params.InputProps.endAdornment}
                                </React.Fragment>
                            ),
                        }}
                    />
                )}
            />
        </Box>
    );
}

export default FacilitiesAutoComplete
